let a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
let b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

function fnConvertNumberToWords(lNumber) {
    let lNum = null;
    if (typeof (lNumber) === 'number') {
        lNum = lNumber.toString();
    }
    else {
        lNum = lNumber;
    }

    if (!lNum || (lNum.length > 9)) {
        return 'overflow';
    }

    let n = ('000000000' + lNum).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) {
        return;
    }

    let lStr = '';

    lStr += (n[1] !== 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
    if (lStr.trim() === 'Crore') {
        lStr = '';
    }

    lStr += (n[2] !== 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
    if (lStr.trim() === 'Lakh') {
        lStr = '';
    }

    lStr += (n[3] !== 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
    if (lStr.trim() === 'Thousand') {
        lStr = '';
    }

    lStr += (Number(n[4]) !== 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
    if (lStr.trim() === 'Hundred') {
        lStr = '';
    }

    lStr += (Number(n[5]) !== 0) ? ((lStr !== '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
    lStr += 'only ';

    return lStr;
}

function fnNumberIndiaFormat(lNum, lDecimals) {
    let lRetVal = null;
    if (lNum) {
        let lNumber = Number(lNum);
        let lNumDecimals = (lDecimals) ? lDecimals : 0;
        lRetVal = lNumber.toLocaleString('en-IN',
            {
                maximumFractionDigits: lNumDecimals,
                style: 'currency',
                currency: 'INR'
            }
        );
    }

    return lRetVal;
}

function fnArraySplit(lDataCollection, lNumChunks, lBalanced) {
    if (lNumChunks < 2) {
        return [lDataCollection];
    }

    let lCollectionLength = (lDataCollection) ? lDataCollection.length : 0;
    let lRetData          = [];
    let lIndex            = 0;
    let lDataSize         = 0;

    if (lCollectionLength % lNumChunks === 0) {
        lDataSize = Math.floor(lCollectionLength / lNumChunks);
        while (lIndex < lCollectionLength) {
            lRetData.push(lDataCollection.slice(lIndex, lIndex += lDataSize));
        }
    }
    else if (lBalanced) {
        while (lIndex < lCollectionLength) {
            lDataSize = Math.ceil((lCollectionLength - lIndex) / lNumChunks--);
            lRetData.push(lDataCollection.slice(lIndex, lIndex += lDataSize));
        }
    }
    else {
        lNumChunks--;
        lDataSize = Math.floor(lCollectionLength / lNumChunks);
        if (lCollectionLength % lDataSize === 0) {
            lDataSize--;
        }

        while (lIndex < lDataSize * lNumChunks) {
            lRetData.push(lDataCollection.slice(lIndex, lIndex += lDataSize));
        }

        lRetData.push(lDataCollection.slice(lDataSize * lNumChunks));
    }

    return lRetData;
}

function fnCreateOTP(lLength, lNumberFlag = false) {
    let lResult = '';
    let lCharLength = 0;
    if (lNumberFlag) {
        const lNumbers = "0123456789";
        lCharLength = lNumbers.length;
        for (let lIndex = 0; lIndex < lLength; lIndex++) {
            lResult += lNumbers.charAt(Math.floor(Math.random() * lNumbers.length));
        }
    }
    else {
        const lCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        lCharLength = lCharacters.length;
        for (let lIndex0 = 0; lIndex0 < lLength; lIndex0++) {
            lResult += lCharacters.charAt(Math.floor(Math.random() * lCharLength));
        }
    }

    return lResult;
}

function fnEscapeRegexChar(lChar) {
    return lChar.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function fnGetTokens(lString, lPlaceHolder='%') {
    if(!lString) return null;

    let lDelimiter = fnEscapeRegexChar(lPlaceHolder);
    const lRegExp = new RegExp(`${lDelimiter}[^${lDelimiter}]+${lDelimiter}`, 'g');
    
    return [...lString.matchAll(lRegExp)].map(lMatch => lMatch[0]);
}

export { fnConvertNumberToWords, fnNumberIndiaFormat, fnArraySplit, fnCreateOTP, fnGetTokens };